/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { TextArea } from 'carbon-components-react';
import { bool } from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { setDraftDiscoveryFilterValue } from '../../../store/reducer';
import { selectDraftDiscoveryFilterValue } from '../../../store/selectors';
import { messages } from './messages';

import './SearchResultDialogs.scss';

export const SearchResultCustomFilter = ({ readOnly }) => {
  const { formatMessage: t } = useIntl();
  const dispatch = useDispatch();

  const [filter, setFilter] = useState(
    useSelector(selectDraftDiscoveryFilterValue)
  );

  const filterChange = e => {
    const filter = e?.target?.value ?? '';
    setFilter(filter);
    dispatch(setDraftDiscoveryFilterValue(filter));
  };

  return (
    <>
      <h4 className={'SearchResultDialogs__title'}>
        {t(messages.customResultsFilter)}
      </h4>
      <p className={'SearchResultDialogs__instruction'}>
        {t(messages.customResultsFilterLabel)}
      </p>
      <TextArea
        className={'SearchResultDialogs__custom-filter'}
        labelText={t(messages.customResultsFilterLabel)}
        hideLabel
        rows={10}
        cols={150}
        maxLength={1024}
        id="SearchReusltCustomFilter__filter-area"
        placeholder={t(messages.customResultsFilterPlaceholder)}
        onChange={filterChange}
        value={filter}
        disabled={readOnly}
      />
    </>
  );
};

SearchResultCustomFilter.propTypes = {
  readOnly: bool
};
